import type { SelectorObject } from '../types/selector-object';

export const createPlanPageHeaderSelectors = {
  planNameInput: 'create-plan-page-header-plan-name-input',
} satisfies SelectorObject<'create-plan-page-header-'>;